import Resource from './base.resource'

export default class DoorsResource extends Resource
{
    constructor() {
        super('doors')
    }
}
